module.exports = __webpack_public_path__ + "static/media/pickled_cherry_tomatoes.619eac5a.png";